import comp from "./VerifyParentInviteCode";
export default comp;
